export default {
  computed: {
    companyOverviewStatusLabelClass() {
      if (this.companyOverview && this.companyOverview.simplestatus) {
        const s = this.companyOverview.simplestatus.name;
        if (s === 'Active') {
          return 'positive';
        }
        if (s === 'Closed' || s === 'Dissolved' || s === 'Converted / Closed') {
          return 'negative';
        }
        return 'neutral';
      }
      return 'neutral';
    },
  },
};
